import { call, put, takeLatest,takeEvery } from 'redux-saga/effects';
import {
  
  fetchStudentProfileSuccess,
  fetchStudentProfileFailure,
  updateStudentProfileSuccess,
  updateStudentProfileFailure,
  updateStudentDOBSuccess,
  updateStudentDOBFailure
} from './_actions';

import * as types from './_actionTypes';
import StudentProfileHelper from '../../../../utils/API/BackendHelper/student/profile';
// Fetch Student Profile Saga
function* fetchStudentProfileSaga() {
  try {
    
    const response =  yield call(StudentProfileHelper.getStudentProfile);

    if (!response.success) {
      throw new Error(response.message || 'Failed to fetch student profile');
    }

    yield put(fetchStudentProfileSuccess(response.data));

  } catch (error) {
    console.error('Error fetching student profile:', error);
    yield put(fetchStudentProfileFailure(error.message));
  }
}

// Update Student Profile Saga
function* updateStudentProfileSaga(action) {
  try {
    const { userId, data } = action.payload;
    const response = yield call(fetch, `/api/students/profile/${userId}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData.message || 'Failed to update student profile');
    }

    const responseData = yield response.json();
    yield put(updateStudentProfileSuccess(responseData.data || responseData));
  } catch (error) {
    console.error('Error updating student profile:', error);
    yield put(updateStudentProfileFailure(error.message));
  }
}

// Update Student DOB Saga
function* updateStudentDOBSaga(action) {
  try {
    const { dob } = action.payload;

    // Validate DOB format
    const dobDate = new Date(dob);
    if (isNaN(dobDate.getTime())) {
      throw new Error('Invalid date format. Please use YYYY-MM-DD');
    }

    // Check if date is in the future
    if (dobDate > new Date()) {
      throw new Error('Date of birth cannot be in the future');
    }

    // Make API call using StudentProfileHelper
    const response = yield call(StudentProfileHelper.updateStudentDOB, dob);

    if (!response.success) {
      throw new Error(response.message || 'Failed to update date of birth');
    }

    yield put(updateStudentDOBSuccess(response.data));
  } catch (error) {
    console.error('Error updating student DOB:', error);
    yield put(updateStudentDOBFailure(error.message));
  }
}

// Watcher Sagas
export function* watchFetchStudentProfile() {
  yield takeLatest(types.FETCH_STUDENT_PROFILE_REQUEST, fetchStudentProfileSaga);
}

export function* watchUpdateStudentProfile() {
  yield takeLatest(types.UPDATE_STUDENT_PROFILE_REQUEST, updateStudentProfileSaga);
}

export function* watchUpdateStudentDOB() {
  yield takeLatest(types.UPDATE_STUDENT_DOB_REQUEST, updateStudentDOBSaga);
}

function* studentProfileSaga() {
  yield takeEvery(types.FETCH_STUDENT_PROFILE_REQUEST, fetchStudentProfileSaga);
  yield takeEvery(types.UPDATE_STUDENT_PROFILE_REQUEST, updateStudentProfileSaga);
  yield takeEvery(types.UPDATE_STUDENT_DOB_REQUEST, updateStudentDOBSaga);
}

// Root Saga
export default studentProfileSaga;
